<!-- [ngClass.xs]="'xs'" -->
<div>
  <app-header></app-header>

  <router-outlet></router-outlet>

  <app-footer></app-footer>

  @if (cookieBanner) {
    <div class="p-4 position-fixed bottom-0 w-100 z-3" style="background-color: #f8f9fa; text-align: center; border-top: 1px solid #e7e7e7;">
      <div class="d-flex gap-4">
       <div>
        We use cookies to enhance your experience, including essential cookies for login and site security.
        We also use third-party services like Google Maps that may set cookies. <a routerLink="/privacy-policy" target="_blank">Learn more</a>.
       </div>
       <div>
         <button class="btn btn-primary" (click)="closeCookieBanner()">Continue</button>
       </div>
      </div>
     </div>
  }
</div>

